import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUtils } from '../utils/modal-utils';
import { Brand } from '../models/product/dto/brand';
import { AddProductGroupsToBrandModalComponent } from '../views/products/components/brands/edit-brands/tabs/brand-product-groups-tab/add-product-groups-to-brand-modal/add-product-groups-to-brand-modal.component';

export class ModalAddProductGroupsToBrand {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    brand: Brand,
    creationMode: boolean = false,
    onClose?: (didAdd: boolean) => void
  ): void {
    ngZone.run(() => {
      const modalRef = ngbModal.open(
        AddProductGroupsToBrandModalComponent,
        ModalUtils.addProductGroupsToBrandModalOptions(injector)
      );
      const compInstance = modalRef.componentInstance as AddProductGroupsToBrandModalComponent;
      compInstance.viewModel.connectToBrand(brand);
      compInstance.viewModel.connectToCreationMode(creationMode);
      modalRef.result.then(didAdd => onClose?.(didAdd === true)).catch(() => {});
    });
  }
}
